import * as React from 'react';

import { Close } from '@mui/icons-material';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { UpdateReportQa } from 'hooks/useUpdateReportQa';
import { useTranslation } from 'react-i18next';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
  updateReportJobStatus: UpdateReportQa;
}

const UnRejectReportMenuItem: React.FC<Props> = ({
  handleClose,
  report,
  updateReportJobStatus,
}) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      onClick={() => {
        updateReportJobStatus(report.id, null, false);
        handleClose();
      }}
    >
      <ListItemIcon>
        <Close fontSize="small" color="error" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.unRejectReport')} />
    </MenuItem>
  );
};

export default UnRejectReportMenuItem;
